import { render, staticRenderFns } from "./personnelEntryModel.vue?vue&type=template&id=3710a680&scoped=true"
import script from "./personnelEntryModel.vue?vue&type=script&lang=js"
export * from "./personnelEntryModel.vue?vue&type=script&lang=js"
import style0 from "./personnelEntryModel.vue?vue&type=style&index=0&id=3710a680&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3710a680",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3710a680')) {
      api.createRecord('3710a680', component.options)
    } else {
      api.reload('3710a680', component.options)
    }
    module.hot.accept("./personnelEntryModel.vue?vue&type=template&id=3710a680&scoped=true", function () {
      api.rerender('3710a680', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/customerManage/personnelDetail/personnelEntryModel.vue"
export default component.exports